import { Search } from "lucide-react";

/**
 * Empty-state card returned by the backend when a live Travelpayouts query
 * produces zero options (or when an upstream API is unavailable). We surface
 * 2-3 alternative searches so the user can immediately retry.
 */
export default function EmptyResultCard({ card, onPlacesToSee }) {
    const { title, message, suggestions = [], category = "flights" } = card || {};

    const dotColor =
        category === "hotels"
            ? "#16A34A"
            : category === "packages"
              ? "#7C3AED"
              : "#2563EB";

    return (
        <article
            className="relative overflow-hidden rounded-2xl border border-dashed border-[#E5E5E5] bg-[#FAFAFA] p-6"
            data-testid="empty-result-card"
        >
            <span
                aria-hidden
                className="absolute right-4 top-4 inline-block h-2.5 w-2.5 rounded-full ring-4"
                style={{ background: dotColor, boxShadow: `0 0 0 4px ${dotColor}1A` }}
            />
            <div className="flex items-start gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-[#737373] ring-1 ring-[#E5E5E5]">
                    <Search size={14} strokeWidth={2} />
                </span>
                <div className="flex-1">
                    <h3 className="text-[15px] font-semibold tracking-tight text-[#0A0A0A]">
                        {title || "No live results"}
                    </h3>
                    {message && (
                        <p className="mt-1 text-[13px] leading-relaxed text-[#737373]">
                            {message}
                        </p>
                    )}
                    {suggestions.length > 0 && (
                        <div className="mt-4 flex flex-wrap gap-2">
                            {suggestions.slice(0, 3).map((s, i) => {
                                // Legacy: plain string. Current: {label, query}.
                                const obj =
                                    typeof s === "string"
                                        ? { label: s, query: s }
                                        : { label: s.label || s.query, query: s.query || s.label };
                                return (
                                    <button
                                        key={i}
                                        type="button"
                                        onClick={() => onPlacesToSee && onPlacesToSee(obj.query)}
                                        data-testid={`empty-suggestion-${i}`}
                                        className="inline-flex items-center gap-1.5 rounded-full border border-[#E5E5E5] bg-white px-3 py-1 text-[12px] font-medium text-[#0A0A0A] transition hover:border-[#0A0A0A] hover:bg-[#F5F5F5]"
                                    >
                                        <span
                                            className="inline-block h-1.5 w-1.5 rounded-full"
                                            style={{ background: dotColor }}
                                        />
                                        {obj.label}
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </article>
    );
}
